import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = ({ ...reset }) => {
  return <Spinner {...reset} />;
};

export default Loader;
